import Phaser from 'phaser';
import { Colors } from '../consts/Colors';
import { Fonts } from '../consts/Fonts';
import RoundedButton from './buttons/RoundedButton';
export default class DeckFond extends Phaser.GameObjects.Container {
    constructor(scene, x, y, { text, totalQuestions }) {
        // Create container
        super(scene, x, y, []);
        scene.add.existing(this);
        this.scene = scene;
        this.totalQuestions = totalQuestions;

        // Ajout fond bleu
        let infoFond = this.scene.add.rexRoundRectangle(0, 0, 560, 253, {tl: 26, tr: 26}, Colors.Elmt.Blue).setOrigin(0.5)
        infoFond.setStrokeStyle(2, Colors.Elmt.OffWhite);
        this.add(infoFond);

        let infoTextFond = this.scene.add.rectangle(infoFond.x , infoFond.y + infoFond.height/2, infoFond.width, 48, Colors.Elmt.OffWhite).setOrigin(0.5)
        infoTextFond.y -= infoTextFond.height/2;
        this.add(infoTextFond);

        this.infoText = this.scene.add.text(infoTextFond.x - infoTextFond.width/2 + 14, infoTextFond.y, text, {
            fontSize: '18px',
            fontFamily: Fonts.MassiliaOblique,
            color: Colors.Text.DarkBlue,
            resolution: 2,
        }).setOrigin(0, 0.5);
        this.add(this.infoText);

        // Ajout numéro question
        if(totalQuestions) {
            this.questionText = this.scene.add.text(infoFond.x + infoFond.width/2 - 24, this.infoText.y + this.infoText.height/2, `1/${totalQuestions}`, {
                fontSize: '20px',
                fontFamily: Fonts.MassiliaExtraLight,
                color: Colors.Text.DarkBlue,
                resolution: 2,
            }).setOrigin(1, 1);
            this.add(this.questionText);
        }

        this.correctionContainer = this.scene.add.container(infoFond.x, infoFond.y, []);
        this.add(this.correctionContainer);
        this.correctionContainer.setAlpha(0);

    }

    setTextInfo(text) {
        this.infoText.setText(text);
    }

    setNumberQuestion(current) {
        if(this.questionText) {
            this.questionText.setText(`${current}/${this.totalQuestions}`)
        }
    }

    displayCorrection(isCorrect, text, buttonText, endFunction) {
        // Fond correction
        const color = isCorrect ? Colors.Elmt.Green : Colors.Elmt.Red;
        const colorText = isCorrect ? Colors.Text.Green : Colors.Text.Red;
        const icon = isCorrect ? 'icon_correct' : 'icon_false';

        const correctionFond = this.scene.add.rexRoundRectangle(0, 0, 560, 253, {tl: 26, tr: 26}, Colors.Elmt.OffWhite).setOrigin(0.5);
        this.correctionContainer.add(correctionFond);

        const image = this.scene.add.image(-correctionFond.width/2 + 26, -correctionFond.height/2 + 40 , icon).setOrigin(0, 0.5);
        this.correctionContainer.add(image);

        const titre = this.scene.add.text(image.x + image.width + 10, image.y, isCorrect ? "BRAVO !" : "MAUVAISE RÉPONSE", {
            fontSize: '32px',
            fontFamily: Fonts.MassiliaBold,
            color: colorText,
            resolution: 2,
        }).setOrigin(0, 0.5);
        this.correctionContainer.add(titre);

        const correctionText = this.scene.add.text(-correctionFond.width/2 + 32, titre.y + titre.height/2 + 16, text, {
            fontSize: '22px',
            fontFamily: Fonts.MassiliaRegular,
            color: Colors.Text.DarkBlue,
            resolution: 2,
            wordWrap: { width: correctionFond.width - 60 }
        }).setOrigin(0, 0);
        this.correctionContainer.add(correctionText);

        const button = new RoundedButton(this.scene, 0, correctionFond.height/2 - 40, {
            width: 188,
            height: 50,
            text: buttonText,
            textColor: Colors.Text.White, 
            backgroundColor: Colors.Elmt.DarkBlue,
            hoverBackgroundColor: Colors.Elmt.Orange,
            fontSize: 24,
        });
        this.correctionContainer.add(button);
        button.setClickFunction(() => {
            endFunction();
        })

        this.scene.tweens.add({
            targets: this.correctionContainer,
            alpha: 1,
            duration: 300
        })

    }

    hideCorrection(){
        this.scene.tweens.add({
            targets: this.correctionContainer,
            alpha: 0,
            duration: 300,
            onComplete: () => {
                this.correctionContainer.removeAll(true)
            }
        })
    }
}